var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',{staticStyle:{"height":"60em"}},[_c('vue-pdf-app',{attrs:{"pdf":_vm.currentDocument.contentDocument,"file-name":_vm.currentDocument.fileName}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }